import {ArchiveRegularIcon} from 'shells/icon/svg/archive-regular-icon';
import {PencilOutlineIcon} from 'shells/icon/svg/pencil-outline-icon';
import {UndoRegularIcon} from 'shells/icon/svg/undo-regular-icon';
import type {ToolbarOption} from 'shells/toolbar/toolbar';

import {PeepRelationshipType} from 'nutshell-graphql-types';

import type {UpdateAccountRelationshipMapInput} from '../../../types';

export function getToolbarOptions(
    accountId: string,
    isFormer: boolean,
    handleUpdateAccountMap: (input: UpdateAccountRelationshipMapInput) => void,
    setIsEditingAccountId: (accountId: string | null) => void
): ToolbarOption[] {
    const toolbarOptions: ToolbarOption[] = [
        {
            id: 'account-edit',
            tooltipText: 'Edit company',
            icon: PencilOutlineIcon,
            onClick: () => {
                setIsEditingAccountId(accountId);
            },
        },
    ];

    if (isFormer) {
        toolbarOptions.push({
            id: 'account-mark-as-current',
            tooltipText: 'Mark as current',
            icon: UndoRegularIcon,
            onClick: () => {
                handleUpdateAccountMap({
                    account: accountId,
                    relationshipType: PeepRelationshipType.UNDEFINED,
                });
            },
        });
    } else {
        toolbarOptions.push({
            id: 'account-mark-as-former',
            tooltipText: 'Mark as former',
            icon: ArchiveRegularIcon,
            onClick: () => {
                handleUpdateAccountMap({
                    account: accountId,
                    relationshipType: PeepRelationshipType.FORMER_CONTACT,
                });
            },
        });
    }

    return toolbarOptions;
}
